import MarginImage from '@images/components/product-card/1_TypesOfProductCard_WithoutMargins.png';
import ContextualBadgeImage from '@images/components/product-card/3_ElementsWithin_ContextualBadge.png';
import * as React from 'react';
export default {
  MarginImage,
  ContextualBadgeImage,
  React
};